module.exports = __webpack_public_path__ + "static/media/todays-appointment-white.bd78c790.svg";